import { Controller } from 'stimulus'

// Jobs-index group selection. Checkboxes exist in every view (table, compact,
// expanded) but only render while the wrapper carries .job-selecting — the
// "Select jobs" button toggles that class, so the index pays nothing at rest
// and rows added later by infinite scroll inherit the mode via CSS.
// Selected ids are injected into the modal's form at submit time.
export default class extends Controller {
  static targets = ['bar', 'count', 'countNoun', 'modal', 'nameInput', 'modeButton', 'modeLabel', 'allShown']

  toggleMode () {
    if (this.selecting()) {
      this.exitMode()
    } else {
      this.element.classList.add('job-selecting')
      this.styleModeButton(true)
      this.refresh()
    }
  }

  done (event) {
    if (event) event.preventDefault()
    this.exitMode()
  }

  exitMode () {
    this.element.classList.remove('job-selecting')
    this.styleModeButton(false)
    this.clear()
  }

  selecting () {
    return this.element.classList.contains('job-selecting')
  }

  styleModeButton (on) {
    if (!this.hasModeButtonTarget) return
    const activeClasses = ['text-blue-600', 'border-blue-400', 'bg-blue-50']
    activeClasses.forEach(klass => this.modeButtonTarget.classList.toggle(klass, on))
    if (this.hasModeLabelTarget) this.modeLabelTarget.textContent = on ? 'Selecting…' : 'Select jobs'
  }

  toggle () {
    this.refresh()
  }

  selectAllShown (event) {
    if (event) event.preventDefault()
    this.boxes().forEach(box => { box.checked = true })
    this.refresh()
  }

  clear () {
    this.boxes().forEach(box => { box.checked = false })
    this.refresh()
  }

  openModal (event) {
    if (event) event.preventDefault()
    if (this.selectedIds().length === 0) return
    this.modalTarget.classList.remove('hidden')
    if (this.hasNameInputTarget) this.nameInputTarget.focus()
  }

  closeModal (event) {
    if (event) event.preventDefault()
    this.modalTarget.classList.add('hidden')
  }

  // Close when the dark overlay itself (not the dialog) is clicked.
  overlayClose (event) {
    if (event.target === event.currentTarget) this.closeModal()
  }

  // The modal holds two forms (create new / add to existing); ids are
  // injected into whichever form is submitting.
  submit (event) {
    const ids = this.selectedIds()
    const container = event.target.querySelector('.job-select-ids')
    if (ids.length === 0 || !container) {
      event.preventDefault()
      return
    }
    container.innerHTML = ''
    ids.forEach(id => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'job_group[job_ids][]'
      input.value = id
      container.appendChild(input)
    })
  }

  boxes () {
    return Array.from(this.element.querySelectorAll('.job-select-box'))
  }

  selectedIds () {
    return this.boxes().filter(box => box.checked).map(box => box.value)
  }

  refresh () {
    if (!this.hasBarTarget) return
    // The bar accompanies selection mode itself, so "All shown" is reachable
    // before the first checkbox is clicked.
    this.barTarget.classList.toggle('hidden', !this.selecting())
    const count = this.selectedIds().length
    if (this.hasCountTarget) this.countTarget.textContent = count
    if (this.hasCountNounTarget) this.countNounTarget.textContent = count === 1 ? 'job' : 'jobs'
    if (this.hasAllShownTarget) this.allShownTarget.textContent = `All shown (${this.boxes().length})`
  }
}
